import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Marketchart } from "./MarketChart";
import { Bookingchart } from "./Bookingchart";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import {
  getDashboardDetail,
  getDashboardGraphAction,
  getDashboardClosing,
  getDashboardPostSale,
  getDashboardSCM,
  getDashboardSourcing,
  getDashboardSiteHead,
  getDashboardReceiptionist,
} from "../../reduxStore/action/dashboardAdmin";
import { getAppointmentList } from "../../reduxStore/action/appointmentActions";
import {
  handleDetailResponse,
  seo,
  handleListResponse,
  isEmpty,
} from "utils/utils";
import CountBoxCard from "./CountBoxCard";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  MIS_RoleId,
  GRE
} from "../../utils/constants";
import { getSourcingManagerList } from "../../reduxStore/action/sourcingManagerAction";
import { getClosingManagerList } from "../../reduxStore/action/closingManagerAction";
import { getAssignCPList } from "reduxStore/action/channelPartnerAction";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [itemOffset, setItemOffset] = useState(0);
  const [dashboardData, setDashboardData] = useState([]);
  const [labelsMarket, setLabelsMarket] = useState([]);
  const [dashboardGraphData, setDashboardGraphData] = useState([]);
  const [labelsBooking, setLabelsBooking] = useState([]);
  const [datasetsBooking, setDatasetsBooking] = useState([]);
  const [exception, setException] = useState(false);
  const [sm, isSm] = useState(false);
  const [stl, isStl] = useState(false);
  const [ctl, isCtl] = useState(false);
  const [cm, isCm] = useState(false);
  const [scm, isScm] = useState(false);
  const [bh, isBh] = useState(false);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
  });
  const [appointmentData, setAppointmentData] = useState([]);

  const [sourcingManagerList, setSourcingManagerList] = useState([]);
  const [closingManagerList, setClosingManagerList] = useState([]);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);

  const sourcingManagerSelecter = useSelector((state) => state?.smData);

  const closingManagerSelecter = useSelector((state) => state?.cmData);

  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner
  );

  const { response: res } = useSelector((state) => state.login);

  const ctlTeam = ClosingTL === res?.data?.role_id;

  const stlteam = SourcingTL === res?.data?.role_id;

  const smTeam = SourcingManager === res?.data?.role_id;

  const misRole = MIS_RoleId === res?.data?.role_id;
  
  const cmScmTeam =
  SCM === res?.data?.role_id || ClosingManager === res?.data?.role_id;
  
  const scmTeam =
  SCM === res?.data?.role_id
  
  const permissionSelector = useSelector((state) => state.permission);
  const { response: permissionResp, isAdmin = false } = permissionSelector;
  const { isSupport } = useSelector((state) => {
    let result =
    state.login.response &&
    (handleDetailResponse(state.login.response.data) || {});
    return {
      isSupport: result?.role_id === SupportRequest,
      // isSubAdmin: result?.role_id === SubAdmin,
    };
  });

  const appointmentListSelector = useSelector((state) => state.appointment);
  const { response: resApp } = appointmentListSelector;

  useEffect(() => {
    if (!isAdmin && cmScmTeam) {
      dispatch(
        getAppointmentList({
          appointment_type: 2,
          limit: 10,
          offset: 0,
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch, isAdmin]);

  useEffect(() => {
    if (stlteam) {
      dispatch(getSourcingManagerList({}));
    }
  }, [dispatch]);

  useEffect(() => {
    if (ctlTeam) {
      dispatch(getClosingManagerList({}));
    }
  }, [dispatch]);

  useEffect(() => {
    if (smTeam) {
      dispatch(
        getAssignCPList({
          user_id: res?.data?._id,
          limit: 10,
          offset: 0,
          // role_id: roleId,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    const responseData = resApp;
    if (responseData?.status === 200) {
      const data = responseData?.data || [];

      if (data.length > 0) {
        setAppointmentData(handleListResponse(data) ? data : []);
      } else {
        setAppointmentData([]);
      }
    } else if (responseData?.status === 201) {
      setAppointmentData([]);
    } else {
      setAppointmentData([]);
    }
  }, [appointmentListSelector, resApp]);

  useEffect(() => {
    const { response = null, create = false } = sourcingManagerSelecter;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setSourcingManagerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setSourcingManagerList([]);
    }
  }, [sourcingManagerSelecter]);

  useEffect(() => {
    const { response = null, create = false } = closingManagerSelecter;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setClosingManagerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setClosingManagerList([]);
    }
  }, [closingManagerSelecter]);

  useEffect(() => {
    const { response = null, create = false } = channelPartnerListSelector;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setchannelPartnerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      } else {
        dispatch(
          getAssignCPList({
            user_id: res?.data?._id,
            limit: 10,
            offset: 0,
          })
        );
      }
    } else {
      setchannelPartnerList([]);
    }
  }, [channelPartnerListSelector]);

  const { response, graphResponse } =
    useSelector((state) => state?.dashboardDetailAdmin) || {};

  const isPermission = (slug) =>
    handleDetailResponse(
      handleListResponse(permissionResp).filter((i) => i.slug === slug)
    )?.permission;
  useEffect(() => {
    if (response) {
      if (response?.status === 200) {
        setDashboardData(response.data);
      } else {
        setDashboardData([]);
      }
    }
    if (graphResponse) {
      if (graphResponse?.status === 200) {
        let {
          total_user,
          total_property,
          total_channelPartner,
          visitor_update,
        } = graphResponse.data;
        let filterData;
        let allUsers = [];
        let allpropertys = [];
        let allChannelPartner = [];
        let marketLabelArray = [];
        // marketLabelArray
        for (let i = 0; i < total_user.length; i++) {
          marketLabelArray.push(total_user[i].date);
        }

        for (let i = 0; i < total_property.length; i++) {
          if (!marketLabelArray.includes(total_property[i].date))
            marketLabelArray.push(total_property[i].date);
        }

        for (let i = 0; i < total_channelPartner.length; i++) {
          if (!marketLabelArray.includes(total_channelPartner[i].date))
            marketLabelArray.push(total_channelPartner[i].date);
        }
        marketLabelArray.sort((a, b) => new Date(a) - new Date(b));
        for (let i = 0; i < marketLabelArray.length; i++) {
          filterData = total_user.filter(function (index) {
            return index.date === marketLabelArray[i];
          });
          if (filterData.length > 0) allUsers.push(filterData[0].count);
          else allUsers.push(0);

          filterData = total_property.filter(function (index) {
            return index.date === marketLabelArray[i];
          });
          if (filterData.length > 0) allpropertys.push(filterData[0].count);
          else allpropertys.push(0);

          filterData = total_channelPartner.filter(function (index) {
            return index.date === marketLabelArray[i];
          });
          if (filterData.length > 0)
            if (filterData[0].count != null)
              if (filterData[0].count > 0)
                allChannelPartner.push(filterData[0].count);
              else allChannelPartner.push(0);
            else allChannelPartner.push(0);
          else allChannelPartner.push(0);
        }
        if (marketLabelArray.length > 0) {
          setLabelsMarket(marketLabelArray);
          setDashboardGraphData([
            {
              label: strings.noOfProperty,
              data: allpropertys,
              backgroundColor: "#4466f2",
            },
            {
              label: strings.noOfUser,
              data: allUsers,
              backgroundColor: "#22af47",
            },
            {
              label: strings.channelParters,
              data: allChannelPartner,
              backgroundColor: "#ff5370",
            },
          ]);
        }
        // bookingLabelArray
        let allVisits = [];
        let allAppointments = [];
        let allBookings = [];
        let allFollowUps = [];
        let allRegistrations = [];
        let bookingLabelArray = [];
        for (let i = 0; i < visitor_update.total_visit.length; i++) {
          bookingLabelArray.push(visitor_update.total_visit[i].date);
        }

        for (let i = 0; i < visitor_update.total_appointment.length; i++) {
          if (
            !bookingLabelArray.includes(
              visitor_update.total_appointment[i].date
            )
          )
            bookingLabelArray.push(visitor_update.total_appointment[i].date);
        }

        for (let i = 0; i < visitor_update.total_booking.length; i++) {
          if (!bookingLabelArray.includes(visitor_update.total_booking[i].date))
            bookingLabelArray.push(visitor_update.total_booking[i].date);
        }
        for (let i = 0; i < visitor_update.total_followUp.length; i++) {
          if (
            !bookingLabelArray.includes(visitor_update.total_followUp[i].date)
          )
            bookingLabelArray.push(visitor_update.total_followUp[i].date);
        }

        for (let i = 0; i < visitor_update.total_registration.length; i++) {
          if (
            !bookingLabelArray.includes(
              visitor_update.total_registration[i].date
            )
          )
            bookingLabelArray.push(visitor_update.total_registration[i].date);
        }
        bookingLabelArray.sort((a, b) => new Date(a) - new Date(b));
        for (let i = 0; i < bookingLabelArray.length; i++) {
          filterData = visitor_update.total_visit.filter(function (index) {
            return index.date === bookingLabelArray[i];
          });
          if (filterData.length > 0) allVisits.push(filterData[0].count);
          else allVisits.push(0);

          filterData = visitor_update.total_appointment.filter(function (
            index
          ) {
            return index.date === bookingLabelArray[i];
          });
          if (filterData.length > 0) allAppointments.push(filterData[0].count);
          else allAppointments.push(0);

          filterData = visitor_update.total_booking.filter(function (index) {
            return index.date === bookingLabelArray[i];
          });
          if (filterData.length > 0) allBookings.push(filterData[0].count);
          else allBookings.push(0);
          filterData = visitor_update.total_followUp.filter(function (index) {
            return index.date === bookingLabelArray[i];
          });
          if (filterData.length > 0) allFollowUps.push(filterData[0].count);
          else allFollowUps.push(0);

          filterData = visitor_update.total_registration.filter(function (
            index
          ) {
            return index.date === bookingLabelArray[i];
          });
          if (filterData.length > 0)
            if (filterData[0].count !== null)
              if (filterData[0].count > 0)
                allRegistrations.push(filterData[0].count);
              else allRegistrations.push(0);
            else allRegistrations.push(0);
          else allRegistrations.push(0);
        }
        if (bookingLabelArray.length > 0) {
          setLabelsBooking(bookingLabelArray);
          setDatasetsBooking([
            {
              label: strings.visitG,
              data: allVisits,
              backgroundColor: "#4466f2",
            },
            {
              label: strings.registrationG,
              data: allRegistrations,
              backgroundColor: "#22af47",
            },
            {
              label: strings.appointmentG,
              data: allAppointments,
              backgroundColor: "#ff5370",
            },
            {
              label: strings.followupG,
              data: allFollowUps,
              backgroundColor: "#ff9f40",
            },
            {
              label: strings.bookingG,
              data: allBookings,
              backgroundColor: "#ffa0b0",
            },
          ]);
        }
      }
    }
  }, [response, graphResponse]);

  const filterDetail = () => {
    if (!handleValid()) {
      setForm({ ...form, isFiltered: true });

      if (isAdmin) {
        dispatch(
          getDashboardDetail({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
        dispatch(
          getDashboardGraphAction({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
      } else if (
        res?.data?.role_id === SourcingManager ||
        res?.data?.role_id === SourcingTL ||
        res?.data?.role_id === sourcing_head_id
      ) {
        dispatch(
          getDashboardSourcing({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
      } else if (
        res?.data?.role_id === ClosingManager ||
        res?.data?.role_id === ClosingTL ||
        res?.data?.role_id === closing_head_id
      ) {
        dispatch(
          getDashboardClosing({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
      } else if (
        res?.data?.role_id === SiteHead ||
        res?.data?.role_id === BusinessHead ||
        res?.data?.role_id === ClusterHead ||
        res?.data?.role_id === admin_id
      ) {
        dispatch(
          getDashboardSiteHead({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
      } else if (res?.data?.role_id === SCM) {
        dispatch(
          getDashboardSCM({
            start_date: form.start_date,
            end_date: form.end_date,
          })
        );
      }
      setItemOffset(0);
    }
  };

  const filterReset = () => {
    setForm({
      isFiltered: false,
      start_date: "",
      end_date: "",
    });
    setFormVaild({
      start_date: "",
      end_date: "",
    });

    if (isAdmin) {
      dispatch(getDashboardDetail());
      dispatch(getDashboardGraphAction());
    } else if (
      res?.data?.role_id === SourcingManager ||
      res?.data?.role_id === SourcingTL ||
      res?.data?.role_id === sourcing_head_id
    ) {
      dispatch(getDashboardSourcing());
    } else if (
      res?.data?.role_id === ClosingManager ||
      res?.data?.role_id === ClosingTL ||
      res?.data?.role_id === closing_head_id
    ) {
      dispatch(getDashboardClosing());
    } else if (
      res?.data?.role_id === SiteHead ||
      res?.data?.role_id === BusinessHead ||
      res?.data?.role_id === ClusterHead ||
      res?.data?.role_id === admin_id
    ) {
      dispatch(getDashboardSiteHead());
    } else if (res?.data?.role_id === SCM) {
      dispatch(getDashboardSCM());
    }
    setItemOffset(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (!form.start_date) {
      formError = true;
      err["start_date"] = strings.startDateErr;
    }
    if (!form.end_date) {
      formError = true;
      err["end_date"] = strings.endDateErr;
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "start_date") {
      setFormVaild({
        ...formVaild,
        start_date: "",
      });
    } else if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  useEffect(() => {
    seo({
      title: "User Dashboard",
      metaDescription: "User Dashboard details",
      canonicalLink: window.location.href,
    });
  }, []);
  useEffect(() => {
    if (isAdmin) {
      dispatch(getDashboardDetail());
      dispatch(getDashboardGraphAction());
      setException(true);
    } else if (
      res?.data?.role_id === SourcingManager ||
      res?.data?.role_id === SourcingTL ||
      res?.data?.role_id === sourcing_head_id
    ) {
      dispatch(getDashboardSourcing());
      setException(true);
    } else if (
      res?.data?.role_id === ClosingManager ||
      res?.data?.role_id === ClosingTL ||
      res?.data?.role_id === closing_head_id
    ) {
      dispatch(getDashboardClosing());
      setException(true);
    } else if (
      res?.data?.role_id === SiteHead ||
      res?.data?.role_id === BusinessHead ||
      res?.data?.role_id === ClusterHead ||
      res?.data?.role_id === admin_id
    ) {
      dispatch(getDashboardSiteHead());
      setException(true);
    } else if (res?.data?.role_id === SCM) {
      dispatch(getDashboardSCM());
      setException(true);
    }

    if (res?.data?.role_id === SourcingManager) {
      isSm(true);
    } else if (res?.data?.role_id === SourcingTL) {
      isStl(true);
    } else if (res?.data?.role_id === ClosingTL) {
      isCtl(true);
    } else if (res?.data?.role_id === ClosingManager) {
      isCm(true);
    } else if (res?.data?.role_id === SCM) {
      isScm(true);
    } else if (res?.data?.role_id === BusinessHead) {
      isBh(true);
    }
  }, [dispatch, isAdmin, res?.data?.role_id]);

  let totalAppointment;
  let totalFollowUp;
  let totalVisit;
  let totalCheckin;
  let totalBooking;
  let activeCp;
  let todayAppointmentCp;
  let activeSm;
  let activeCm;

  switch (res?.data?.role_id) {
    case SourcingManager:
    case SourcingTL:
    case sourcing_head_id:
      // Map data for sourcing-related roles

      // Add any other sourcing-specific fields
      totalAppointment = dashboardData?.today_site_visit;
      totalFollowUp = dashboardData?.today_followup;
      totalVisit = dashboardData?.today_visit;
      totalCheckin = dashboardData?.today_checking;
      totalBooking = dashboardData?.total_booking;
      activeCp = dashboardData?.active_cp;
      todayAppointmentCp = dashboardData?.today_Apointment_Cp;
      activeSm = dashboardData?.total_sorcing_manager;

      break;

    case ClosingManager:
    case ClosingTL:
    case closing_head_id:
      // Map data for closing-related roles

      // Add any other closing-specific fields
      

      totalAppointment = dashboardData?.total_appointment;
      totalFollowUp = dashboardData?.today_followup;
      totalVisit = dashboardData?.total_visit;
      totalCheckin = dashboardData?.today_site_visit;
      totalBooking = dashboardData?.total_booking;
      activeCm = dashboardData?.total_closing_manager;

      break;

    case SiteHead:
    case BusinessHead:
    case admin_id:
      // Map data for site head/admin-related roles
      // dashboardData?.total_visit
      // dashboardData?.total_appoinment
      // dashboardData?.today_checking
      // dashboardData?.total_booking

      // dashboardData?.today_followup
      totalAppointment = dashboardData?.total_appoinment;
      totalFollowUp = dashboardData?.today_followup;
      totalVisit = dashboardData?.total_visit;
      totalCheckin = dashboardData?.today_checking;
      totalBooking = dashboardData?.total_booking;

      break;

    case SCM:
      // Map data for sourcing-related roles

      // Add any other sourcing-specific fields
      totalAppointment = dashboardData?.today_site_visit;
      totalFollowUp = dashboardData?.today_followup;
      totalVisit = dashboardData?.today_visit;
      totalCheckin = dashboardData?.today_checkin;
      totalBooking = dashboardData?.total_booking;
      activeCp = dashboardData?.active_cp;
      todayAppointmentCp = dashboardData?.today_Apointment_Cp;

      break;

    case GRE:
      // Map data for GRE role (visitor management focused)
      // GRE role primarily handles visitors, so map visitor-related metrics
      totalVisit = dashboardData?.today_visit || dashboardData?.total_visit;
      totalAppointment = dashboardData?.today_site_visit || dashboardData?.total_appoinment;
      // Add other relevant metrics for GRE role
      break;

    default:
      console.log("No matching role detected");
      // You can also map generic data if no specific role matches

      break;
  }

  return (
    <div className="page-body">
      <div className="container-fluid">
        <div className="page-header">
          {!isSupport && (
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-body">
                        <form className="theme-form">
                          <div className="row">
                            <div className="col-md-4">
                              <span className="cardText">
                                {strings.startDate}
                              </span>
                              <div
                                className="input-group date"
                                id="dt-date"
                                data-target-input="nearest"
                              >
                                <input
                                  className="form-control datetimepicker-input digits"
                                  type="date"
                                  data-target="#dt-date"
                                  name="start_date"
                                  value={form.start_date}
                                  onChange={handleInputField}
                                  min={form.start_date}
                                />
                              </div>
                              {formVaild.start_date && (
                                <span style={{ color: "red" }}>
                                  {formVaild.start_date}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              <span className="cardText">
                                {strings.endDate}
                              </span>
                              <div
                                className="input-group date"
                                id="dt-date"
                                data-target-input="nearest"
                              >
                                <input
                                  className="form-control datetimepicker-input digits"
                                  type="date"
                                  name="end_date"
                                  value={form.end_date}
                                  onChange={handleInputField}
                                  min={form.start_date}
                                  // max={form.end_date}
                                />
                              </div>
                              {formVaild.end_date && (
                                <span style={{ color: "red" }}>
                                  {formVaild.end_date}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4 pt-5">
                              <div className="form-group d-flex justify-content-end">
                                <button
                                  className="btn btn-warning mr-4"
                                  type="button"
                                  onClick={filterDetail}
                                >
                                  {strings.search}
                                </button>
                                <button
                                  className="btn btn-dark"
                                  type="button"
                                  onClick={filterReset}
                                >
                                  {strings.reset}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>{strings.dashboard}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Container-fluid starts*/}
      <div className="container-fluid">
        <div className="row">
          {!misRole && (
          <div className="col-lg-12">
            <div className="row">
              {isAdmin && isPermission("property_management") && (
                <div className="col-md-4">
                  <CountBoxCard
                    navigateLink="/property"
                    label={strings.noOfProperty}
                    count={dashboardData?.total_property}
                  />
                </div>
              )}
              {(isAdmin || isPermission("user_management")) && (
                <div className="col-md-4">
                  <CountBoxCard
                    navigateLink="/user"
                    label={strings.noOfUser}
                    count={dashboardData?.total_user}
                  />
                </div>
              )}
              {isAdmin && isPermission("channel_management") && (
                <div className="col-md-4">
                  <CountBoxCard
                    navigateLink="/channelpartner"
                    label={strings.channelParters}
                    count={dashboardData?.total_channelPartner}
                  />
                </div>
              )}
            </div>
          </div>
          )}


            {!misRole && (
          <div className="col-lg-12">
              <div className="row">
                <div className="col-sm-6">
                  {isAdmin && <h5>{strings.visitorUpdate}</h5>}
                </div>
              </div>


            <div className="card-body">
              <div className="row">
                {((!isAdmin && isSupport) || isPermission("raise_ticket")) && (
                  <div className="col-sm-6">
                    <CountBoxCard
                      label={strings.todayRaiseTicket}
                      count={dashboardData?.today_ticket}
                    />
                  </div>
                )}
                {((!isAdmin && isSupport) || isPermission("raise_ticket")) && (
                  <div className="col-sm-6">
                    <CountBoxCard
                      label={strings.openRaiseTicket}
                      count={dashboardData?.total_open_ticket}
                    />
                  </div>
                )}
                {(isAdmin || isPermission("visitor_management")) &&
                  !ctl &&
                  !cm && (
                    <div className={isAdmin ? "col-sm-6" : "col-sm-4"}>
                      <CountBoxCard
                        label={
                          form?.isFiltered
                            ? strings.totalVisit
                            : strings.todatyVisit
                        }
                        count={
                          isAdmin
                            ? dashboardData?.visitor_update?.total_visit
                            : totalVisit
                        }
                        navigateLink="/visitor"
                      />
                    </div>
                  )}
                {isAdmin && isPermission("registration_management") && (
                  <div className="col-sm-6">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.totalRegistration
                          : strings.todayRegistration
                      }
                      count={dashboardData?.visitor_update?.total_registration}
                    />
                  </div>
                )}
                {(isAdmin || isPermission("appointment_management")) && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.totalAppointment
                          : strings.todayAppointment
                      }
                      count={
                        isAdmin
                          ? dashboardData?.visitor_update?.total_appointment
                          : totalAppointment
                      }
                    />
                  </div>
                )}
                {!isAdmin && isPermission("appointment_management") && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.totalCheckin
                          : strings.todayCheckin
                      }
                      count={totalCheckin}
                    />
                  </div>
                )}
                {(isAdmin || isPermission("followup_management") || bh) &&
                  !sm &&
                  !stl && (
                    <div className="col-sm-4">
                      <CountBoxCard
                        label={
                          form?.isFiltered
                            ? strings.totalFollowup
                            : strings.todayFollowup
                        }
                        count={
                          isAdmin
                            ? dashboardData?.visitor_update?.total_followUp
                            : totalFollowUp
                        }
                        navigateLink="/todayFollowup"
                      />
                    </div>
                  )}
                {(isAdmin || isPermission("booking_management")) && !stl && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.totalBooking
                          : strings.todayBooking
                      }
                      count={
                        isAdmin
                          ? dashboardData?.visitor_update?.total_booking
                          : totalBooking
                      }
                    />
                  </div>
                )}

                {(sm || stl) && isPermission("appointment_ site_visit") && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.totalAppointment
                          : strings.todayAppointment
                      }
                      count={totalAppointment}
                    />
                  </div>
                )}

                {(sm || scm) && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered ? strings.activeCP : strings.activeCP
                      }
                      count={activeCp}
                    />
                  </div>
                )}

                {(sm || scm) && isPermission("appointment_ site_visit") && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered
                          ? strings.todayAppointmentWithCp
                          : strings.todayAppointmentWithCp
                      }
                      count={todayAppointmentCp}
                    />
                  </div>
                )}

                {stl && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered ? strings.activeSm : strings.activeSm
                      }
                      count={activeSm}
                    />
                  </div>
                )}

                {ctl && (
                  <div className="col-sm-4">
                    <CountBoxCard
                      label={
                        form?.isFiltered ? strings.activeCm : strings.activeCm
                      }
                      count={activeCm}
                    />
                  </div>
                )}

                {!isAdmin &&
                  !exception &&
                  isPermission("booking_management") && (
                    <div className="col-sm-4">
                      <CountBoxCard
                        label={
                          form?.isFiltered
                            ? strings.totalVisit
                            : strings.recovery
                        }
                        count={dashboardData?.visitor_update?.recovery}
                      />
                    </div>
                  )}
                {!isAdmin &&
                  !exception &&
                  isPermission("booking_management") && (
                    <div className="col-sm-4">
                      <CountBoxCard
                        label={
                          form?.isFiltered
                            ? strings.totalVisit
                            : strings.cancelBooking
                        }
                        count={dashboardData?.visitor_update?.cancelBooking}
                      />
                    </div>
                  )}
              </div>
            </div>
          </div>
            )}


          {isAdmin && (
            <div className="col-lg-12">
              <div className="card">
                <div className="card-header b-l-primary">
                  <h5>{strings.performance} </h5>
                </div>
                <div className="card-body">
                  {labelsMarket.length > 0 ? (
                    <div className="market-chart">
                      <Marketchart
                        labels={labelsMarket}
                        datasets={dashboardGraphData}
                      />
                    </div>
                  ) : (
                    <h5 className="text-center text-danger">
                      {strings.notavailable}
                    </h5>
                  )}
                </div>
              </div>
            </div>
          )}

          {cmScmTeam && !scmTeam && (
            <div className="col-xl-12">
              <div className="card height-equal">
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>{strings.todayAppointments}</h5>
                    </div>
                    <div className="col-sm-6">
                      <div className="pull-right right-header">
                        {/* <span>{strings.month}</span> */}
                        <span>
                          <button
                            className="btn btn-primary btn-pill"
                            onClick={() => {
                              navigatpage("/today_appointments");
                            }}
                          >
                            {strings.seemore}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Check if appointmentData has data */}
                  {appointmentData && appointmentData.length > 0 ? (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Visitor Name</th>
                          <th>Property</th>
                          <th>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appointmentData.map((appointment, index) => (
                          <tr key={index}>
                            <td>{`${appointment.customer_first_name || ""} ${appointment.customer_last_name || ""}`.trim()}</td>{" "}
                            {/* Customer name */}
                            <td>{appointment.property_title}</td>{" "}
                            {/* Property name */}
                            <td>{appointment.appointment_time}</td>{" "}
                            {/* Appointment time */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <h5 className="text-center">{strings.notavailable}</h5>
                  )}
                </div>
              </div>
            </div>
          )}

          {stlteam && (
            <div className="col-xl-12">
              <div className="card height-equal">
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>{strings.sourcingManager}</h5>
                    </div>
                    <div className="col-sm-6">
                      <div className="pull-right right-header">
                        {/* <span>{strings.month}</span> */}
                        <span>
                          <button
                            className="btn btn-primary btn-pill"
                            onClick={() => {
                              navigatpage("/sourcing_managers");
                            }}
                          >
                            {strings.seemore}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Check if appointmentData has data */}
                  {sourcingManagerList && sourcingManagerList.length > 0 ? (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>SM Name</th>
                          <th>Visitor</th>
                          <th>Site Visit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sourcingManagerList.slice(0, 5).map(
                          (
                            sm,
                            index // Show only top 5 items
                          ) => (
                            <tr key={index}>
                              <td>{sm.user_name}</td> {/* Customer name */}
                              <td>{sm.total_visit}</td> {/* Visitor count */}
                              <td>{sm.total_site_visit}</td>{" "}
                              {/* Site visit count */}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <h5 className="text-center">{strings.notavailable}</h5>
                  )}
                </div>
              </div>
            </div>
          )}

          {ctlTeam && (
            <div className="col-xl-12">
              <div className="card height-equal">
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>{strings.closingManager}</h5>
                    </div>
                    <div className="col-sm-6">
                      <div className="pull-right right-header">
                        {/* <span>{strings.month}</span> */}
                        <span>
                          <button
                            className="btn btn-primary btn-pill"
                            onClick={() => {
                              navigatpage("/closing_managers");
                            }}
                          >
                            {strings.seemore}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Check if appointmentData has data */}
                  {closingManagerList && closingManagerList.length > 0 ? (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>CM Name</th>
                          <th>Status</th>
                          <th>Appointment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {closingManagerList.slice(0, 5).map(
                          (
                            cm,
                            index // Show only top 5 items
                          ) => (
                            <tr key={index}>
                              <td>{cm.user_name}</td> {/* Customer name */}
                              <td>
                                {cm.status ? strings.active : strings.deactive}
                              </td>{" "}
                              {/* Visitor count */}
                              <td>{cm.today_appoinment}</td>{" "}
                              {/* Site visit count */}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <h5 className="text-center">{strings.notavailable}</h5>
                  )}
                </div>
              </div>
            </div>
          )}

          {smTeam && (
            <div className="col-xl-12">
              <div className="card height-equal">
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>{strings.channelPartner}</h5>
                    </div>
                    <div className="col-sm-6">
                      <div className="pull-right right-header">
                        {/* <span>{strings.month}</span> */}
                        <span>
                          <button
                            className="btn btn-primary btn-pill"
                            onClick={() => {
                              navigatpage("/channelpartner");
                            }}
                          >
                            {strings.seemore}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Check if appointmentData has data */}
                  {getchannelPartnerList && getchannelPartnerList.length > 0 ? (
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>CP Name</th>
                          <th>Visitor</th>
                          <th>Site Visit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getchannelPartnerList.slice(0, 5).map(
                          (
                            cm,
                            index // Show only top 5 items
                          ) => (
                            <tr key={index}>
                              <td>{cm.user_name}</td> {/* Customer name */}
                              <td>{cm.total_visit}</td> {/* Visitor count */}
                              <td>{cm.total_site_visit}</td>{" "}
                              {/* Site visit count */}
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <h5 className="text-center">{strings.notavailable}</h5>
                  )}
                </div>
              </div>
            </div>
          )}

          {isAdmin && !misRole && (
            <div className="col-xl-12">
              <div className="card height-equal">
                <div className="card-header card-header-border">
                  <div className="row">
                    <div className="col-sm-6">
                      <h5>{strings.newchannelPartner}</h5>
                    </div>
                    <div className="col-sm-6">
                      <div className="pull-right right-header">
                        {/* <span>{strings.month}</span> */}
                        <span>
                          <button
                            className="btn btn-primary btn-pill"
                            onClick={() => {
                              navigatpage("/channelpartner");
                            }}
                          >
                            {strings.seemore}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {dashboardData?.new_channel_partner?.length > 0 ? (
                    dashboardData?.new_channel_partner?.map((item, index) => {
                      return (
                        index <= 10 && (
                          <div key={index} className="new-users">
                            <div className="media pt-4">
                              {item?.profile_picture ? (
                                <div
                                  style={{
                                    backgroundImage: `url(${item?.base_url}${item?.profile_picture})`,
                                    width: 45,
                                    height: 45,
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                    position: "relative",
                                    backgroundSize: "cover",
                                    backgroundPosition: "50%",
                                    backgroundRepeat: "no-repeat",
                                  }}
                                ></div>
                              ) : (
                                <span>
                                  <img
                                    className="rounded-circle image-radius m-r-15"
                                    src="/assets/images/user.png"
                                    alt=""
                                  />
                                </span>
                              )}
                              <div className="media-body">
                                <h6 className="mb-0 f-w-700 m-l-15">
                                  {item?.agent_name}
                                </h6>
                                <p className="m-l-15">{item?.email}</p>
                              </div>
                            </div>
                          </div>
                        )
                      );
                    })
                  ) : (
                    <h5 className="text-center">{strings.notavailable}</h5>
                  )}
                </div>
              </div>
            </div>
          )}
          {isAdmin && (
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>
                    {strings.visitorUpdate} {strings.performance}
                  </h5>
                </div>

                {labelsBooking.length > 0 ? (
                  <div className="market-chart">
                    <Bookingchart
                      labels={labelsBooking}
                      datasets={datasetsBooking}
                    />
                  </div>
                ) : (
                  <h5 className="text-center text-danger">
                    {strings.notavailable}
                  </h5>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Container-fluid Ends*/}
    </div>
  );
};

export default Index;
